<template>
    <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
        <div style="padding:0px;width:100%;">
            <div class="whiteBox dashboard_topic">
                <div class="portlet-title">
                    <i class="el-icon-d-arrow-right">&nbsp;</i>三大垂媒线索清洗时长
                </div>
                <div class="portlet-content">
                    <div class="filter-container" style="padding-top: 0px; height: 28px;">
                        <el-radio-group class="filter-item" size="mini" v-model="listQuery.dateType" @change="listQuery.searchDate = new Date();">
                            <el-radio-button :label="3">按月</el-radio-button>
                            <el-radio-button :label="4">按年</el-radio-button>
                            <el-radio-button :label="5">自定义</el-radio-button>
                        </el-radio-group>
                        <el-date-picker key="month" :picker-options="datePickerOption" style="height: 28px;" class="filter-item" size="mini" v-if="listQuery.dateType == 3" :clearable="false" v-model="listQuery.searchDate" type="month" format="yyyy年MM月" placeholder="选择月">
                        </el-date-picker>
                        <el-date-picker key="year" :picker-options="datePickerOption" style="height: 28px;" class="filter-item" size="mini" v-if="listQuery.dateType == 4" :clearable="false" v-model="listQuery.searchDate" type="year" format="yyyy年" placeholder="选择年">
                        </el-date-picker>
                        <el-date-picker key="dateRange" :picker-options="dateRangeOption" style="height: 28px;" size="mini" v-if="listQuery.dateType == 5" :clearable="false" v-model="listQuery.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                        <el-button class="filter-item" size="mini" type="info" icon="el-icon-search" @click="doSearch">查看</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-refresh" @click="doReset">重置</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-download" @click="doExport">导出</el-button>
                    </div>
                    <el-table :data="list" stripe  id="table" v-loading="listLoading">
                        <el-table-column prop="month" label="">
                            <template slot="header" slot-scope="scope">
                                {{ isCustomize ? '时间（自定义）' : '时间（月）' }}
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.month != undefined ? scope.row.month : `${scope.row.startDate}~${scope.row.endDate}` }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="avgClearSeconds1" label="">
                            <template slot="header" slot-scope="scope">
                                09:00-17:59平均清洗时长
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    :content="tips.tip1"
                                >
                                    <i
                                        class="fa fa-question-circle-o"
                                        aria-hidden="true"
                                        slot="reference"
                                    ></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="avgClearSeconds2" label="">
                            <template slot="header" slot-scope="scope">
                                18:00-19:59平均清洗时长
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    :content="tips.tip2"
                                >
                                    <i
                                        class="fa fa-question-circle-o"
                                        aria-hidden="true"
                                        slot="reference"
                                    ></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
    data() {
        return {
            dayjs: dayjs,
            dealer: this.$common.getDealer(),
            list: null,
            listLoading: false,
            isCustomize: false,
            listQuery: {
                dateType: 3,
                searchDate: new Date(),
                dateRange: [new Date(Date.now() - 86400000), new Date(Date.now() - 86400000)],
            },
            datePickerOption: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() < new Date('2026-03-01').getTime();
                },
            },
            // 用于临时记录第一次选中的开始时间
            minDate: '',
            maxDate: '',
            dateRangeOption: {
              // 核心：动态控制禁用日期
              disabledDate: (time) => {
                if (this.minDate && !this.maxDate) {
                  // 设置跨度为60天（毫秒数计算：60 * 24 * 3600 * 1000）
                  const range = 60 * 24 * 3600 * 1000;
                  const minTime = this.minDate.getTime();
                  // 限制：只能选择开始日期前后 60 天内，且不能3月份之前的日期
                  return (
                    time.getTime() < minTime - range ||
                    time.getTime() > minTime + range ||
                    time.getTime() < new Date('2026-02-28').getTime()
                  );
                //   time.getTime() > Date.now() ||
                }
                // 默认只限制不能3月份之前的日期
                return time.getTime() < new Date('2026-02-28').getTime();
              },
              // 核心：在选中第一个日期时触发，记录开始时间
              onPick: ({ maxDate, minDate }) => {
                this.minDate = minDate;
                this.maxDate = maxDate; 
              }
            },
            tips: {
                tip1: '仅统计每月（当月截止T-1天）线索清洗开始时间在09:00-17:59 （新疆经销商除外）这个时间段内，由汽车之家、易车、懂车帝3平台流入线索的平均清洗时长（第一次有效/无效/未接通的时间-线索进入商家系统的时间），等同王朝、海洋商家首次回访时长数据。',
                tip2: '仅统计每月（当月截止T-1天）线索清洗开始时间在18:00-19:59这个时间段内，由汽车之家、易车、懂车帝3平台流入线索的平均清洗时长（第一次有效/无效/未接通的时间-线索进入商家系统的时间），等同王朝、海洋商家首次回访时长数据。',
            }
        };
    },
    mounted() {
        this.doSearch();
    },
    methods: {
        doSearch() {
            this.listLoading = true
            const url = this.listQuery.dateType == 5 ? "/v1/reportRpc/averageClearSecondsCustomize" : "/v1/reportRpc/averageClearSeconds";
            this.isCustomize = (this.listQuery.dateType == 5);
            this.list = [];
            this.$httpAuth
                .post(url, this.getParams())
                .then((response) => {
                    const data = response.data;
                    this.list = data.data || [];
                    this.listLoading = false;
                }).catch(() => {
                    this.listLoading = false;
                });
        },
        doReset() {
            this.list = null;
            this.listLoading = false;
            this.listQuery = {
                dateType: 3,
                searchDate: new Date(),
                dateRange: [new Date(Date.now() - 86400000), new Date(Date.now() - 86400000)],
                page: 1,
                limit: 10,
            };
            this.doSearch();
        },
        doExport() {
            const loading = this.$loading({
                lock: true,
                text: '正在导出中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const url = this.listQuery.dateType == 5 ? "/v1/reportRpc/averageClearSecondsCustomize" : "/v1/reportRpc/averageClearSeconds";
            this.$httpAuth
                .post(url, {...this.getParams(), isExport: true})
                .then((response) => {
                    const { file, total } = response.data
                    if (total > 2000) {
                        this.$message({
                            customClass: 'export-message',
                            dangerouslyUseHTMLString: true,
                            message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
                            duration: 2000
                        });
                    }
                    setTimeout(() => {
                        loading.close()
                        let a = document.createElement('a');
                        a.href = file;
                        a.click();
                    }, 1000);
                })
                .catch(() => {
                    loading.close()
                });
        },
        getParams() {
            let startDate = '';
            let endDate = ''
            if (this.listQuery.dateType == 3) {
                startDate = this.$common.getFirstDayOfMonth(this.listQuery.searchDate);
                endDate = this.$common.getEndDayOfMonth(this.listQuery.searchDate);
            }
            if (this.listQuery.dateType == 4) {
                startDate = this.$common.getFirstDayOfYear(this.listQuery.searchDate);
                endDate = this.$common.getEndDayOfYear(this.listQuery.searchDate);
            }

            if (this.listQuery.dateType == 5) {
                startDate = dayjs(this.listQuery.dateRange[0]).unix();
                endDate = dayjs(this.listQuery.dateRange[1]).unix();
            }
            if(this.listQuery.dateType == 5) {
              return {
                dealerId: this.dealer.dealerId,
                startDate,
                endDate
              }
            } else {
              const targetDate = dayjs(endDate)
              const currentDate = dayjs().format('YYYY-MM-DD')
              const isGreaterOrEqualAlt  = !targetDate.isBefore(currentDate)
              return {
                  dealerId: this.dealer.dealerId,
                  startDate: dayjs(startDate).isBefore(dayjs('2026-03-01')) ? '2026-03-01' : startDate,
                  endDate: isGreaterOrEqualAlt ? (dayjs().subtract(1, 'day').format('YYYY-MM-DD')) : endDate,
              }                
            }

        }
    }
}
</script>

<style>

</style>
